<template>
  <div class="nav-2depth-wrap ticket-2depth" v-if="$route.name !== 'oksusu'">
    <div class="inner-wrap">
      <ul>
        <li v-for="(menuItem, index) in menuList" :key="index"
             :class="menuItem.menu === 'pooqzone' ? 'mr0 ' + setTabCss(menuItem.menu) : setTabCss(menuItem.menu)">
          <router-link :to="menuItem.path">{{menuItem.title}}</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      menuList: [
        {
          menu: 'index',
          path: '/voucher/index',
          title: 'wavve 이용권'
        },
        {
          menu: 'regist',
          path: '/voucher/regist',
          title: '쿠폰·코인'
        },
        {
          menu: 'wavveon',
          path: '/voucher/wavveon',
          title: '웨이브온 이용권'
        }
      ]
    }
  },
  methods: {
    setTabCss (menu) {
      return menu === this.$route.meta.menu ? 'nav-depth-on' : ''
    }
  }
}
</script>
